<div class="input-container"
    [ngClass]="customClasses" 
    [class.is-disabled]="isDisabled" 
    [class.is-readonly]="isReadonly" 
    [popperTrigger]="ngxPopperjsTriggers.hover"
    [tabindex]="tabIndex"
    [popper]="tooltipErrTemplate" 
    [popperDisabled]="!showErrorTooltip || !errorList || errorList?.length === 0" popperAppendTo="body" 
    [popperPlacement]="ngxPopperjsPlacements.TOP" 
    [popperPreventOverflow]="false" 
    [popperHideOnScroll]="true"
    [class.has-error]="showErrorBorder && errorList?.length > 0" 
    [style.borderColor]="showErrorBorder && errorList?.length > 0 ? null : (overrideBorderColor ? overrideBorderColor : null)"
    (mouseleave)="mouseLeave($event)" 
    (mouseenter)="mouseEnter($event)"
    popperApplyClass="error">
    <div class="image-upload-wrap" 
         [style.display]="(isVisibleUploadAction$ | async) ? null : 'none'">
        <input #inputFile class="file-upload-input" [attr.disabled]="isDisabled ? '' : null"
            (change)="fileSelected($event)" type="file" [accept]="accept" />
        <div class="drag-text">
            <h3>
                {{addFileText}}</h3>
            <svg-icon fontSize="40px" key="attachment"></svg-icon>
        </div>
    </div>
    <div class="file-upload-content" [style.display]="!(isVisibleUploadAction$ | async) ? null : 'none'">
        @if(showProgressBar$ | async) {
            <nts-loader [isVisible]="true" [animation]="true"></nts-loader>
        }
        @else {
            <div class="file-upload-description" [innerHTML]="fileDescription$ | async"></div>
            <div class="image-title-wrap">
                <nts-filled-button [isDisabled]="isDisabled" [type]="filledButtonType.Info" (onClicked)="reset()" [label]="removeFileText"></nts-filled-button>
            </div>
        }
    </div>
</div>

<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of errorList">
        {{ item }}
    </ng-container>
</popper-content>


